export const journalPrompts = [
  {
    id: 1,
    text: "HOW WOULD I DESCRIBE MY MOOD AROUND ALLOCATING MY RESOURCES?",
    audioFile: "/assets/page2/prompts/prompt1.mp3",
    examples: [
      "Practical and heartfelt. I invest in everyday living and in simple moments with the ones I endear—turning the seemingly mundane into meaning and weaving lasting memories with the ones I adore.",
      "Vision-driven and expansive. The mood that reflects investments in experiences that help me feel both established and adventurous.",
      "Empowered and purposeful. My entrepreneurial spirit guides my investments, creating pathways for ideas to come to life and nurturing them so they can continue to flourish.",
      "Grounded in balance and sustainability. My mood mirrors my wellness philosophy, investing in routines, health, and experiences that nourish me.",
      "Open and adaptable. It centers around flexibility—investing in experiences, learning, and assets that create a more spacious life.",
      "Purpose-led and outward-looking. I invest so I can support causes, communities, and people I believe in, letting my resources echo my worldview."
    ]
  },
  {
    id: 2,
    text: "WHAT DOES FREEDOM LOOK AND FEEL LIKE TO ME?",
    audioFile: "/assets/page2/prompts/prompt2.mp3",
    examples: [
      "Freedom as inner wisdom, a trust in the unseen, the quiet knowing that life can unfold in ways that's quite magical, a miracle even.",
      "Freedom as an adventurous spirit: an openness to new ideas, letting curiosity guide me into new ways of seeing.",
      "Freedom is the open-armed feeling of saying yes to life — yes to ideas, yes to growth, yes to the marvelous unknown.",
      "Freedom is the ability to look at life and feel awe — to recognize the marvel in the ordinary and the extraordinary alike."
    ]
  },
  {
    id: 3,
    text: "IS THERE ANYTHING I'M CURRENTLY DOING PURELY OUT OF OBLIGATION?",
    audioFile: "/assets/page2/prompts/prompt3.mp3",
    examples: [
      "Keeping the same work routine due to habit and expectation, even when it feels like autopilot.",
      "Showing up to weekly team syncs mostly because it's expected; feeling drained and multi-tasking afterward.",
      "Saying yes to social plans I'm not really interested, rather not disappointing others.",
      "Attending certain family or community events out of duty, even when my body and schedule clearly need rest.",
      "Signing up for courses or programs because I feel I should be improving, not because I'm genuinely drawn to them.",
      "Continuing to do things the same way because it feels safer, even when a different approach might be better.",
      "I take on emotional weight—checking in, smoothing conflicts, remembering details—for everyone, even when I need care myself."
    ]
  },
  {
    id: 4,
    text: "WHAT INVESTMENTS WOULD HELP ME FEEL MORE ALIGNED WITH WHO I ALREADY AM (NOT THE FUTURE ME)?",
    audioFile: "/assets/page2/prompts/prompt4.mp3",
    examples: [
      "Investing in stable, long-term assets that reflect my preference for consistency, security, and resilience.",
      "Investing in fitness and nutrition coaching to align with my current lifestyle.",
      "Enrolling in leadership training or executive coaching that strengthens my skills and equips me for broader positive impact.",
      "I'd fund structured learning in areas that fascinate me and expand my worldview.",
      "I'd invest in my home environment, making it calmer, simpler, and more functional.",
      "Investing in systems that reduce friction, automation or organization, to declutter my days.",
      "Setting aside time and resources for communities and causes that have a place in my heart.",
      "Setting aside funds for soul-restoring experiences — group dinners with close friends, culturally resonant or low-key travel, and short retreats in beautiful, scenic places."
    ]
  },
  {
    id: 5,
    text: "PLEASE REFLECT ON HOW STEADINESS SHOWS UP IN LIFE",
    audioFile: "/assets/page2/prompts/prompt5.mp3",
    examples: [
      "Supported Stability: Trusting in my routines, relationships, and financial choices. I can sustain my lifestyle with ease.",
      "Reliable Foundations: Trusting in my work. It's valued, compliant, and aligned with my deeper mission.",
      "Inner harmony: Trusting in myself — my decisions, resilience, and ability to adapt. I moved through uncertainty feeling more grounded, confident, and capable of navigating change.",
      "Emotional Safety: I feel safe to express myself without fear of judgment or rejection. I can share openly, set boundaries, and still feel loved and respected."
    ]
  },
  {
    id: 6,
    text: "WHAT DOES \"SECURITY\" MEAN TO ME, OR WHEN WOULD I FEEL LIGHT & SECURE?",
    audioFile: "/assets/page2/prompts/prompt6.mp3",
    examples: [
      "Lightness comes when I trust the structures I've already put in place; security comes as a trust in the knowing that life continues to offer more than can currently be seen.",
      "When I can disagree and still feel secure with my partner, knowing our relationship can hold honest conversations.",
      "When my environment ensures me that I'm supported, a morning with no rush, a conversation where I feel understood, a space that feels uncluttered and warm.",
      "It's the feeling of \"more than enough\" inside. I'm more than enough for me.",
      "When my daily systems protect my joy.",
      "It's the sense of inner spaciousness, and steadiness — a way of being where I feel nourished, supported, and free."
    ]
  },
  {
    id: 7,
    text: "I'D PREFER MONETARY VALUE TO EXPAND BEYOND SECURITY SIMPLY BECAUSE...",
    audioFile: "/assets/page2/prompts/prompt7.mp3",
    examples: [
      "The sense of freedom I feel on vacation is deeply nostalgic and monetary beyond security allows investment in experiences and assets that enrich my life now (like a vacation property) without compromising financial safety.",
      "Beauty deserves breathing room, so my mind-body connection can feel considered, calm, and nourished.",
      "I'm drawn to immerse myself in experiences that expand my perspective — beyond maintaining my current lifestyle.",
      "Because of the freedom to explore creative ventures and projects that may not have an immediate payoff but are deeply engaging.",
      "I can invest in my long-term health and vitality—care, training, and environments that keep my body and mind strong over time.",
      "I'd love to support communities and causes that matter deeply to me, knowing giving can be sustained and strategic."
    ]
  },
  {
    id: 8,
    text: "WHO IS THE VERSION OF ME WHEN THIS EXPANSION OF FINANCIAL VALUE BECOMES A LEGACY THAT CONTINUES LONG AFTER I'M GONE?",
    audioFile: "/assets/page2/prompts/prompt8.mp3",
    examples: [
      "I'd become a person who their inner steadiness meets change with grounded confidence, understanding that resilience itself becomes a generational imprint.",
      "I'm someone who amplifies freedom and emotional safety for my loved ones, so they feel both supported and free to be themselves.",
      "A gentle life curator of meaningful joy.",
      "Someone who focuses on what endures—systems, values, and opportunities that outlast me and support others.",
      "A lifestyle visionary with soulful travel storytelling, turning experiences into memories, meaning, and inspiration for others.",
      "A calm, confident leader who uplifts others, modeling grounded decision-making and generous collaboration.",
      "Someone who opens opportunities for others and creates lasting impact through education, access, and values-aligned giving."
    ]
  }
];
